import { useCurrentProject } from './useCurrentProject';

export const useCurrentProjectId = () => {
  const project = useCurrentProject();
  return (project && project.id) || null;
};
